/* =========================================================
   NVQ THEME — Gedeelde JS-utilities voor Norvique
   Namespace: nvq-
   Laad dit bestand met defer, na de HTML van de secties
   ========================================================= */

(function () {
  'use strict';

  if (window.NVQ && window.NVQ.__initialized) {
    return;
  }

  const NVQ = {
    __initialized: true,
    registry: new Map(),

    /**
     * Registreer een init-functie onder een naam, zodat deze
     * zowel bij paginalading als bij Theme Editor section:load
     * opnieuw uitgevoerd kan worden.
     */
    register(name, initFn) {
      this.registry.set(name, initFn);
    },

    runAll(context) {
      /* `name` bestond hier niet en viel terug op window.name, waardoor een
         foutmelding altijd een lege naam toonde. Nu de echte sleutel. */
      this.registry.forEach((fn, name) => {
        try {
          fn(context || document);
        } catch (err) {
          console.error('[NVQ] init error in "' + name + '":', err);
        }
      });
    },
  };

  window.NVQ = NVQ;

  /* ---------------------------------------------------------
     Accordion
     Verwacht markup:
     <div data-nvq-accordion>
       <button data-nvq-accordion-trigger aria-expanded="false" aria-controls="ID">...</button>
       <div data-nvq-accordion-panel id="ID" hidden>...</div>
     </div>
  --------------------------------------------------------- */
  function initAccordions(root) {
    const accordions = root.querySelectorAll('[data-nvq-accordion]:not([data-nvq-bound])');

    accordions.forEach((accordion) => {
      accordion.setAttribute('data-nvq-bound', 'true');
      const triggers = accordion.querySelectorAll('[data-nvq-accordion-trigger]');

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', function () {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          const panelId = trigger.getAttribute('aria-controls');
          const panel = document.getElementById(panelId);

          if (!panel) return;

          trigger.setAttribute('aria-expanded', String(!expanded));
          panel.hidden = expanded;
        });
      });
    });
  }

  NVQ.register('accordions', initAccordions);

  /* ---------------------------------------------------------
     Focus trapping voor drawers/modals (cart drawer, filterdrawer)
     Verwacht markup:
     <div data-nvq-drawer data-nvq-drawer-open="false">
       <button data-nvq-drawer-close>...</button>
       ... focusable content ...
     </div>
  --------------------------------------------------------- */
  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(drawer) {
    const focusable = drawer.querySelectorAll(FOCUSABLE_SELECTOR);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handleKeydown(e) {
      if (e.key === 'Escape') {
        closeDrawer(drawer);
        return;
      }

      if (e.key !== 'Tab') return;

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    drawer.__nvqKeydownHandler = handleKeydown;
    drawer.addEventListener('keydown', handleKeydown);
    first.focus();
  }

  function releaseFocus(drawer) {
    if (drawer.__nvqKeydownHandler) {
      drawer.removeEventListener('keydown', drawer.__nvqKeydownHandler);
      delete drawer.__nvqKeydownHandler;
    }
  }

  function openDrawer(drawer) {
    drawer.setAttribute('data-nvq-drawer-open', 'true');
    drawer.__nvqLastFocused = document.activeElement;
    trapFocus(drawer);
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawer) {
    drawer.setAttribute('data-nvq-drawer-open', 'false');
    releaseFocus(drawer);
    document.body.style.overflow = '';
    if (drawer.__nvqLastFocused && typeof drawer.__nvqLastFocused.focus === 'function') {
      drawer.__nvqLastFocused.focus();
    }
  }

  function initDrawers(root) {
    const drawers = root.querySelectorAll('[data-nvq-drawer]:not([data-nvq-bound])');

    drawers.forEach((drawer) => {
      drawer.setAttribute('data-nvq-bound', 'true');

      const closeButtons = drawer.querySelectorAll('[data-nvq-drawer-close]');
      closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => closeDrawer(drawer));
      });

      const overlay = drawer.querySelector('[data-nvq-drawer-overlay]');
      if (overlay) {
        overlay.addEventListener('click', () => closeDrawer(drawer));
      }
    });

    /* Openers kunnen los in de DOM staan (bijv. cart-icoon in de header) */
    const openers = root.querySelectorAll('[data-nvq-drawer-open-trigger]:not([data-nvq-bound])');
    openers.forEach((opener) => {
      opener.setAttribute('data-nvq-bound', 'true');
      opener.addEventListener('click', () => {
        const targetId = opener.getAttribute('data-nvq-drawer-open-trigger');
        const target = document.getElementById(targetId);
        if (target) openDrawer(target);
      });
    });
  }

  NVQ.openDrawer = openDrawer;
  NVQ.closeDrawer = closeDrawer;
  NVQ.register('drawers', initDrawers);

  /* ---------------------------------------------------------
     Init bij eerste paginalading
  --------------------------------------------------------- */
  function init() {
    NVQ.runAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---------------------------------------------------------
     Herinitialiseren in de Shopify Theme Editor
  --------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (event) {
    NVQ.runAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    /* Ruim event listeners op om memory leaks te voorkomen */
    const boundElements = event.target.querySelectorAll('[data-nvq-bound]');
    boundElements.forEach((el) => el.removeAttribute('data-nvq-bound'));
  });

  document.addEventListener('shopify:block:select', function (event) {
    const block = event.target;
    if (block && block.scrollIntoView) {
      block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
})();